import { LitElement, css, svg } from '~/lib/bn-lit-element';

class BnLogoShield extends LitElement {
  static get styles() {
    return css`
      :host {
        display: inline-block;
      }
      svg {
        width: 100%;
      }
      svg g {
        fill: var(--logo-fill-colour, var(--primary));
      }
    `;
  }

  render() {
    return svg`
      <svg preserveAspectRatio="xMinYMin meet" version="1.1" viewBox="0 0 24.612 27.91" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        <g transform="translate(-8.7097 -122.9)">
          <path d="m21.212 122.9s-4.8065 2.8347-12.502 3.6152c-0.0082 11.157 2.6178 18.26 12.52 24.295 10.123-6.607 12.294-12.452 12.077-24.533-6.4099-0.11-12.095-3.3769-12.095-3.3769zm0.05551 1.6335 2.5471 1.2618c-0.22069-0.0552 0.44836 20.69 0.44836 20.69l-2.3118 2.4029c-0.57295-3.4526-0.92541-10.641-7.814-14.796-0.2069 0.66207-0.4025 1.7989-0.4025 1.7989-0.13792-1.5448 0.02293-2.7167 0.02293-2.7167s0.93697 0.36896 2.068 1.0862l0.77422-7.7zm2.9164 1.444 0.90034 0.44655 0.08508 0.97879-0.93353-0.26733zm1.3879 0.68793 0.34276 0.16956 2.1567 15.319-0.72051 0.86233zm-1.3221 0.76939 0.9456 0.26492 0.09594 1.1085-0.99086-0.25042zm0.06578 1.4652 1.0053 0.24682 0.11043 1.2666-1.0578-0.22751zm0.07603 1.6806 1.0735 0.22086 0.12672 1.4609-1.1333-0.1937zm0.0875 1.9473 1.152 0.18405 0.14785 1.7035-1.2214-0.14484zm0.10258 2.2834 1.2431 0.13095 0.175 2.0119-1.3246-0.0736zm-9.6002 1.3825c1.969 7.0994 5.4467 12.641 5.4467 12.641 0.0027 8e-3 -4.4218-4.5654-5.4467-12.641zm9.7227 1.333 1.3499 0.0549 0.21 2.4126-1.4477 0.0278zm1.6257 3.2254 0.25586 2.946-1.5955 0.17983-0.13819-3.0691zm-0.41517 3.9833-0.8406 1.0065-0.03983-0.88645z" color="#000000" color-rendering="auto" dominant-baseline="auto" image-rendering="auto" shape-rendering="auto" solid-color="#000000" style="font-feature-settings:normal;font-variant-alternates:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-variant-numeric:normal;font-variant-position:normal;isolation:auto;mix-blend-mode:normal;shape-padding:0;text-decoration-color:#000000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-orientation:mixed;text-transform:none;white-space:normal"/>
        </g>
      </svg>
    `;
  }
}

window.customElements.define('bn-logo-shield', BnLogoShield);
